import { gql } from '@grandvisionhq/graphql';

const CREATE_ACCOUNT = gql`
  mutation CreateB2CCustomerAccount($input: CreateB2CCustomerAccountInput!) {
    createB2CCustomerAccount(input: $input) {
      customerId
    }
  }
`;

export { CREATE_ACCOUNT };
//# sourceMappingURL=create-account.js.map
